const SLICES = {
	ACCOUNTS: 'accounts',
	ASSERTIONS: '_assertions',
	RISKS: '_risks',
	JOURNALSOURCE: 'journalSource',
	TRIAL_BALANCE: 'trialBalances',
	ESTIMATES: 'estimates',
	STENTITIES: 'stEntities',
	MAP_PSP_OSP_ACCOUNTS: 'mapPSPOSPAccounts'
};

export default SLICES;
